import lrUserSelect from './_src/lrUserSelect2.vue'
lrUserSelect.install = function(Vue) {
  Vue.component(lrUserSelect.name, lrUserSelect)
}
export default lrUserSelect